import React from 'react';
import { Button, HStack } from '@chakra-ui/react';
import { TRANSITION_BUTTON } from '@/components/ui/motion.ts';

interface DialogActionRowProps {
	cancelLabel: string;
	confirmLabel: string;
	onCancel: () => void;
	onConfirm?: () => void;
	cancelType?: 'button' | 'submit' | 'reset';
	confirmType?: 'button' | 'submit' | 'reset';
	confirmDisabled?: boolean;
	confirmLoading?: boolean;
	confirmLoadingText?: string;
	confirmBg?: string;
	confirmColor?: string;
	cancelBg?: string;
	cancelColor?: string;
}

const DialogActionRow: React.FC<DialogActionRowProps> = ({
	cancelLabel,
	confirmLabel,
	onCancel,
	onConfirm,
	cancelType = 'button',
	confirmType = 'button',
	confirmDisabled = false,
	confirmLoading = false,
	confirmLoadingText,
	confirmBg = 'primary.fixed',
	confirmColor = 'text.onPrimary',
	cancelBg = 'surface.default',
	cancelColor = 'fg.muted',
}) => (
	<HStack gap={3}>
		<Button
			flex={1}
			type={cancelType}
			onClick={onCancel}
			borderRadius="full"
			h="auto"
			py={2.5}
			textStyle="body.sm"
			fontWeight="medium"
			bg={cancelBg}
			color={cancelColor}
			border="none"
			boxShadow="xs"
			_hover={{
				boxShadow: 'sm',
			}}
			_active={{
				bg: 'surface.subtle',
				boxShadow: 'xs',
			}}
			transition={TRANSITION_BUTTON}
		>
			{cancelLabel}
		</Button>
		<Button
			flex={1}
			type={confirmType}
			onClick={onConfirm}
			borderRadius="full"
			h="auto"
			py={2.5}
			textStyle="body.sm"
			fontWeight="semibold"
			bg={confirmDisabled || confirmLoading ? 'brand.200' : confirmBg}
			color={confirmColor}
			border="none"
			disabled={confirmDisabled}
			loading={confirmLoading}
			loadingText={confirmLoadingText}
			cursor={confirmDisabled || confirmLoading ? 'default' : 'pointer'}
			boxShadow="xs"
			_hover={
				confirmDisabled || confirmLoading
					? {}
					: {
							bg: 'brand.800',
						}
			}
			_active={
				confirmDisabled || confirmLoading
					? {}
					: {
							bg: 'brand.900',
						}
			}
			transition={TRANSITION_BUTTON}
		>
			{confirmLabel}
		</Button>
	</HStack>
);

export default DialogActionRow;
